import { bangkokGetYourGuideAttractions } from '../../../config/affiliates/attractions/get-your-guide/bangkok';
import { bangkokKlookAttractions } from '../../../config/affiliates/attractions/klook/bangkok';
import { Content } from '../../types';

export const bangkokContent: Content = {
  title: 'בנגקוק - העיר והאגדה!',
  imageUrl: '/images/thailand/bangkok/bangkok-wide-2.jpeg',
  introduction:
    'כל מה שצריך לדעת על לינה, תחבורה ואטרקציות בעיר הבירה של תאילנד - מדריך מקיף לשנת 2025',
  sections: [
    {
      title: 'היכרות עם בנגקוק - עיר ללא הפסקה',
      type: 'sub-headers',
      content: [
        {
          subtitle: '',
          text: 'בנגקוק (Bangkok), הינה עיר הבירה והמרכז הפוליטי, התרבותי, הכלכלי והתיירותי של תאילנד. מטרופולין ענק, שוקק חיים וצבעוני, המציע מגוון חוויות בלתי נגמר - מקדשים, ארמונות, מוזיאונים, פסטיבלים ומרכזי קניות, המשלבים שווקים מסורתיים לצד קניונים מודרניים, מסורת וקדמה, עבר והווה, וכל זאת בתוך עיר תוססת ודינמית.',
        },
        {
          subtitle: '',
          text: "בנגקוק הינה אחת הערים הגדולות באסיה ומבין יעדי התיירות הפופולריים בעולם. העיר ממוקמת משני צידי נהר הצ'או פראייה, בסמוך למפרץ תאילנד. בעיר מתגוררים מעל 10 מיליון תושבים, ובמטרופולין כולו כ - 14 מיליון. היא נוסדה כבירתה החדשה של תאילנד בשנת 1782 על ידי המלך ראמה הראשון ומאז חוותה תהפוכות רבות, בעיקר בתחום הפוליטי, שהשפיעו על כלל היבטי החיים במדינה",
        },
        {
          subtitle: '',
          text: 'ברחבי העיר ניתן לחוות את השילוב הייחודי בין התרבות התאילנדית המסורתית לבין הקדמה והמודרניות המתפתחת ללא הרף. מצד אחד - מקדשים מרהיבים, ארמונות מפוארים ושווקים אותנטיים המציעים הצצה לאורח החיים המסורתי של תושבי העיר. מצד שני - מגדלי מגורים ועסקים המתנשאים לגבהים אדירים, מרכזי קניות עצומים ומרכזי בילוי שאין להם תחרות, הממחישים את התפתחותה של העיר לכדי מטרופולין גלובלי מוביל.',
        },
        {
          subtitle: '',
          text: 'הניגודים הללו באים לידי ביטוי גם באורח החיים של תושביה. ניתן למצוא נזירים בגלימות כתומות פוסעים בשקט בין גורדי השחקים, לצד צעירים מתלבשים בבגדים אופנתיים הנוהרים למועדונים ולמסעדות יוקרה. באותו הרחוב ניתן לראות דוכני אוכל רחוב המציעים מאכלים מסורתיים לצד מסעדות מפוארות עם מטבח עילי. בעוד שבשעות הבוקר תושבי העיר עוצרים ומשתחווים בפני פסלים בודהיסטיים ומדליקים קטורת, בערבים אותם רחובות הופכים לזירה תוססת של חיי לילה ושווקים מוארים באורות צבעוניים.',
        },
      ],
    },
    {
      title: 'מזג אוויר בבנגקוק - מתי כדאי לבקר?',
      description:
        'בנגקוק מאופיינת באקלים טרופי לאורך כל השנה, אך יש עונות שכדאי לקחת בחשבון:',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'העונה היבשה (נובמבר-פברואר)',
          text: 'אידיאלית לטיולים, מזג אוויר נעים ויבש.',
        },
        {
          subtitle: 'העונה החמה (מרץ-מאי)',
          text: 'טמפרטורות גבוהות, מתאימה לאוהבי חום.',
        },
        {
          subtitle: 'העונה הרטובה (יוני-אוקטובר)',
          text: 'גשמים בעיקר בשעות אחר הצהריים, מחירים נמוכים יותר.',
        },
      ],
      sectionLink: {
        url: '/international/thailand/article/thailand-weather',
        text: 'למדריך המלא אודות מזג האוויר בתאילנד',
      },
    },
    {
      title: 'אזורים מומלצים ללינה בבנגקוק',
      type: 'sub-headers',
      description:
        'בנגקוק מציעה מגוון רחב של מקומות לינה - מאכסניות בתקציב נמוך ועד למלונות פאר יוקרתיים המשקיפים על הנהר או ממוקמים בלב המרכזים הקוסמופוליטיים של העיר. להלן סקירה אודות אזורי הלינה העיקריים המומלצים לתיירים:',
      content: [
        {
          subtitle: 'אזור הקואסאן Khao San Road',
          text: `לב האזור התרמילאי של העיר. רחוב הקואסאן והסביבה מהווים מוקד מרכזי לתרמילאים מכל העולם. האזור שוקק חיים עם ברים, פאבים, מועדונים, מסעדות, מסאג'ים, שווקים ועוד וניתן למצוא באזור, בכל מקום, את כלל השירותים הנדרשים עבור תיירים. אידיאלי למחפשי אווירה צעירה, מחירים נוחים ומפגש עם מטיילים ממקומות שונים בעולם. באזור זה (רחוב Phra Artit) ממוקם בית חב"ד למטיילים ולפיכך, האזור אידיאלי מאוד עבור התיירים המבקשים לשהות באזור של בית חב"ד.`,
        },
        {
          subtitle: 'סוקומוויט Sukhumvit',
          text: "שדרה מרכזית, ארוכה (ממשיכה עד פטאיה!) ומלאת חיים, הנחשבת לאחת מהמובילות בעיר. תמצאו כאן מלונות יוקרה, דירות נופש, מסעדות מכל הסוגים, חיי לילה סוערים, מסאג'ים ואף קניונים. תחנות BTS פזורות לאורכה ומקשרות בקלות בינה לכל חלקי העיר. אזור מעולה למחפשים חוויית לינה עירונית, מודרנית, קרבה לקניונים ונוחה לתנועה.",
        },
        {
          subtitle: 'אסוק Asok',
          text: "ממוקם בצומת ובו קווי התחבורה העיקריים BTS ו-MRT ובכך מאפשר מעבר מהיר ויעיל לאזורים רבים בעיר. זהו אחד האזורים המרכזיים, הקרובים לקניונים (טרמינל 21), עסקים, שגרירות ישראל, פארק בנצ'טיקי ופארק לומפיני, מסעדות וחיי לילה. מתאים מאוד למטיילים הרוצים לשלב בין תיירות, קניות, אזורים ירוקים ונוחות תחבורתית.",
        },
        {
          subtitle: 'סילום Silom',
          text: "מרכז העסקים של העיר, אך גם אזור עשיר בתרבות וחיי לילה. כאן תמצאו את פארק לומפיני ופארק בנצ'טיקי, את שוק הלילה פטפונג ומסעדות מצוינות. מתאים לאנשי עסקים ולתיירים המחפשים שילוב בין עבודה להנאה.",
        },
        {
          subtitle: 'סיאם Siam',
          text: 'מרכז הקניות של בנגקוק, אזור מצוין למשפחות ולאוהבי שופינג. כאן תמצאו את Central World Siam Paragon, MBK, Siam Discovery, ועוד. בנוסף, תחבורה קלה בזכות BTS Siam Interchange. אידיאלי למחפשים גישה מהירה לכל מקום וקרבה לאטרקציות מודרניות.',
        },
        {
          subtitle: "נהר הצ'או פראייה Chao Phraya River",
          text: 'אזור יוקרתי אך רגוע ומרגיע יותר, על שפת הנהר. בתי מלון מפוארים עם נוף מרהיב, גישה לסירות, קרבה לארמון המלך ולמקדשים המרכזיים. מצוין לזוגות בירח דבש ולאלו שמחפשים שקט לצד נוחות.',
        },
        {
          subtitle: 'פראטונם (Pratunam)',
          text: 'קרוב לאזור  סיאם ומושלם למעוניינים בשופינג בתקציב נוח - שווקים סיטונאיים, קניון פלטינום, ואוכל רחוב מעולה. המחירים לרוב נוחים ולא יקרים, והאווירה תוססת.',
        },
      ],
    },
    {
      title: "נהר הצ'או פראייה",
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok/bangkok-article-6.jpeg',
    },
    {
      title: 'תחבורה ציבורית בבנגקוק',
      type: 'sub-headers',
      description:
        'מערכת התחבורה הציבורית בעיר נוחה ומתקדמת ומהווה את אחד היתרונות הגדולים של העיר - זולה, נוחה ויעילה:',
      sectionLink: {
        url: '/international/thailand/article/bangkok-transportation',
        text: 'למדריך המלא על התחבורה הציבורית בבנגקוק',
      },
      content: [
        {
          subtitle: 'BTS - Sky Train',
          text: 'רכבת עילית מודרנית ומהירה. עוברת דרך אזורי המפתח של העיר כמו סיאם, סוקומוויט, סילום ועוד. אידיאלי לשעות העומס.',
        },
        {
          subtitle: 'MRT',
          text: "משלימה את ה-BTS ומגיעה גם לאזורים המכוסים על ידי הרכבת העילית. מעולה עבור הנוסעים לשוק צ'אטוצ'אק, ל-צ'יינה טאון ועוד.",
        },
        {
          subtitle: 'סירות הנהר (Chao Phraya Express)',
          text: "תחבורה זולה, נעימה ומיוחדת לאורך נהר הצ'או פראייה. נוחה מאוד למעוניינים לבקר באטרקציות ההיסטוריות כמו ארמון המלך, וואט פו, וואט ארון ועוד. יש גם סירות קו בצבעים שונים המציעות תחנות עצירה שונות לכל אורך הנהר.",
        },
        {
          subtitle: 'סירות תעלה Khlong Boats',
          text: 'תחבורה זולה, מהירה ומאוד יעילה. מהווה דרך ייחודית ונוסטלגית לחצות את העיר ומאפשרת חיבור מהיר בין מרכז העיר (פראטונאם - תחנה ראשית) לבין האזורים אשר ממזרח (Asok) וממערב (Pan Fa Pier). גם אם לא הכי נוחות - תמיד חוסכות פקקים!',
        },
        {
          subtitle: 'מוניות',
          text: 'זמינות מאוד, יש לדרוש הפעלת מונה (או סיכום מחיר מראש). נסיעה עם אפליקציות Bolt ו - Grab, מומלצת ונוחה.',
        },
        {
          subtitle: 'מוניות אופנוע',
          text: 'זמינות מאוד, זולות ומהירות, יש להקפיד להזמין  באמצעות Bolt או Grab, מתאים מאוד עבור מטיילים יחידים.',
        },
        {
          subtitle: 'טוקטוקים',
          text: 'חוויה מקומית צבעונית, לא זולה ולכן, חשוב לסכם מחיר מראש.',
        },
        {
          subtitle: 'אוטובוסים ציבוריים',
          text: 'האופציה הכי זולה, אך פחות מומלצת לתיירים, עקב מורכבות הקווים והעומס.',
        },
      ],
    },
    {
      title: 'Sky Train',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok/bangkok-article-3.jpg',
    },
    {
      title: 'דרכי הגעה לבנגקוק ונמלי תעופה בעיר',
      type: 'sub-headers',
      description:
        'בנגקוק מהווה את שער הכניסה המרכזי לתאילנד עבור מרבית המטיילים, עם שני נמלי תעופה בינלאומיים חשובים:',
      content: [
        {
          subtitle: 'נמל התעופה הבינלאומי Suvarnabhumi (BKK)',
          text: 'זהו הנמל הראשי והמודרני של בנגקוק ואחד העמוסים בעולם, הממוקם כ-30 ק"מ מזרחית לעיר. רוב הטיסות הבינלאומיות מגיעות ונוחתות כאן, כולל טיסות ישירות מישראל (אל על). מהנמל ניתן להגיע לעיר בקלות דרך:<br>✓ <strong>רכבת מהירה (Airport Rail Link)</strong> - חיבור מהיר ונוח לאזור מרכז העיר (תחנות Makkasan ו-Phaya Thai).<br>✓ <strong>מוניות</strong> - זמינות בשפע, יש לוודא שימוש במונה ו/או מחיר סגור מראש.<br>✓ <strong>שאטלים פרטיים</strong> או רכבים מוזמנים דרך אפליקציות כמו Grab.<br>✓ <strong>אוטובוסים ציבוריים</strong> (בעלות זולה) המבצעים קווים קבועים למרכז העיר ולאזור הקאוסאן.',
        },
        {
          subtitle: 'נמל התעופה Don Mueang (DMK)',
          text: 'הנמל הוותיק יותר, משמש כיום בעיקר טיסות פנים וטיסות לואו קוסט (חברות כמו AirAsia, Nok Air ו-Lion Air), ממוקם כ-24 ק"מ צפונית למרכז העיר. אפשרויות התחבורה ממנו כוללות:<br>✓ <strong>מוניות</strong> (עם מונה בלבד)<br>✓ <strong>אוטובוסים ציבוריים</strong> בעלות זולה<br>✓ <strong>רכבות</strong> (רכבת פרברית) - מתאימה בעיקר למטיילים עם זמן פנוי וללא ציוד כבד.',
        },
        {
          subtitle: 'מעבר בין שני הנמלים',
          text: 'ניתן לעבור בין שני נמלי תעופה אלו בעזרת שאטלים חינמיים (בהצגת כרטיס טיסת המשך), או מונית (הנסיעה אורכת כשעה-שעה וחצי, תלוי בעומס התנועה).',
        },
        {
          subtitle: 'הגעה לבנגקוק מערים אחרות בתאילנד',
          text: 'ניתן להגיע לבנגקוק ובכלל זה, לנמל התעופה Suvarnabhumi מערים אחרות וממחוזות אחרים במדינה, הן באמצעות טיסות פנים המבוצעות ע"י מגוון רחב של חברות תעופה תאילנדיות והן באמצעות שירותי אוטובוסים ורכבות.',
        },
      ],
      is12GoBanner: true,
    },
    {
      title: 'אטרקציות מרכזיות בבנגקוק',
      type: 'sub-headers',
      description: 'מה תוכלו לעשות במסגרת שהות קצרה בבנגקוק?<br/>',
      content: [
        {
          subtitle: 'סיור רגלי במרכז ההיסטורי',
          text: "מה תוכלו לעשות במסגרת שהות קצרה בבנגקוק?<br/> לשוהים בעיר לזמן קצר ומעוניינים להכיר את פניה ההיסטוריים, נמליץ לצאת לסיור רגלי שיתחיל בארמון המלך המרשים - לב ההיסטוריה והתרבות התאילנדית, להמשיך למקדש וואט פו (הבודהה השוכב) - מקדש אייקוני ומרשים מבחינת אדריכלות וממנו אל וואט ארון הממוקם על הגדה המערבית של הנהר והינו אחד מהמקדשים המפורסמים והחשובים בתאילנד. לאחר מכן, בקרו בשוק הפרחים הצבעוני ולבסוף, לקראת שקיעה, בקרו בגשר הזיכרון (Memorial Bridge), ממנו נשקף מראה פנורמי עוצר נשימה של קו הרקיע של העיר המשתלב עם נהר הצ'או פראייה. לסיום ובשעות הלילה, מומלץ לבקר בשוק האוכל הלילי של צ'יינה טאון - חוויה קולינרית עשירה בצבעים, ריחות וטעמים ייחודיים.<br/>את חלקו הראשון של הסיור (ארמון המלך, וואט פו ווואט ארון, נמליץ לחוות במסגרת סיור מודרך ואת החלק השני (שוק הפרחים, גשר הזכרון וצ'יינה טאון, במסגרת סיור עצמאי).",
          link: {
            url: bangkokGetYourGuideAttractions['grand-palace-tour'],
            text: 'לחצו כאן ובדקו את הסיור הרגלי במרכז ההיסטורי בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'וואט ארון (Wat Arun)',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok/bangkok-article-5.jpeg',
    },
    {
      title: 'נקודות תצפית',
      type: 'bullet-list',
      description:
        'האטרקציות הגבוהות והמרשימות ביותר בבנגקוק להתרגשות וצפייה בעיר מלמעלה:',
      content: [
        {
          title: 'Mahanakhon Skywalk',
          description:
            'אחת מנקודות התצפית הגבוהות והמרשימות בבנגקוק, הממוקמת בקומה ה-78 של מגדל King Power Mahanakhon. מכאן נשקף נוף פנורמי של העיר כולה, כולל חוויה מרגשת של הליכה על רצפת זכוכית בגובה עוצר נשימה (מומלץ לקראת שקיעה)',
          link: {
            url: bangkokGetYourGuideAttractions['mahanakhon-sky-walk'],
            text: 'לחצו כאן ובדקו את מגדל מהאנאקון בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          title: 'Baiyoke Sky Tower',
          description:
            'המגדל הגבוה ביותר בתאילנד (עד לאחרונה), מציע תצפית 360 מעלות בקומות העליונות. תוכלו ליהנות מארוחת ערב במסעדה מסתובבת ולצפות בנופי העיר בשקיעה או בלילה - חוויה רומנטית ומרשימה (מומלץ לקראת שקיעה)',
          link: {
            url: bangkokGetYourGuideAttractions['baiyoke-sky-tower'],
            text: 'לחצו כאן ובדקו את מגדל באיוק סקיי בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          title: 'Sky Bar Lebua',
          description:
            'חוויה לילית עם נוף עוצר נשימה בבר הממוקם על גג מלון Lebua at State Tower, בקומה ה-63, בר הידוע בנוף הפנורמי המרהיב שלו על העיר ובאווירה המיוחדת שלו והופיע בסרט "בדרך לחתונה עוצרים בבנגקוק". במקום תמצאו קוקטיילים מיוחדים ואווירה יוקרתית ומומלץ להגיע בשעות הערב המוקדמות כדי ליהנות מהשקיעה המרהיבה ומהאורות של העיר. הזמנת מקום מראש מומלצת, במיוחד בסופי שבוע',
          link: {
            url: bangkokGetYourGuideAttractions['sky-bar-lebua'],
            text: 'לחצו כאן ובדקו את בר לבואה בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'פארקים, פארקי שעשועים ואטרקציות למשפחות',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Lumpini Park',
          text: '"ריאה ירוקה בלב בנגקוק". פארק מרכזי ופופולרי בלב בנגקוק, מושלם לטיול רגוע, ריצה או שייט באגם עם סירות פדלים. המקום מציע אווירה ירוקה ושלווה, במיוחד בשעות הבוקר המוקדמות.',
          link: {
            url: '/international/thailand/destination/lumphini-park',
            text: 'לקריאת המאמר המלא על פארק לומפיני',
          },
        },
        {
          subtitle: 'Benchakiti Park',
          text: '"פנינה ירוקה בלב בנגקוק". הפארק העירוני הגדול בבנגקוק, עם אגם, שבילים ירוקים, גשרים ונוף פתוח, המציעים שקט ושלווה בלב העיר.',
          link: {
            url: '/international/thailand/destination/benchakitti-park',
            text: "לקריאת המאמר המלא על פארק בנצ'קיטי",
          },
        },
        {
          subtitle: 'Dream World',
          text: 'פארק המזכיר את דיסני, עם אזורי נושא כמו "ארץ הפנטזיה" ו"עולם ההרפתקאות". תמצאו כאן מתקנים לקטנים וגדולים, מופעים, אזור שלג מלאכותי (Snow Town) ועוד. חוויה מהנה למשפחות עם ילדים בגילאי 4-12.',
          link: {
            url: bangkokGetYourGuideAttractions['dream-world-park'],
            text: 'לחצו כאן ובדקו את Dream World בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Siam Amazing Park',
          text: 'פארק שעשועים ומים גדול במיוחד, עם רכבות הרים, מתקנים לילדים ובריכות עם מגלשות מים. מתאים לכל המשפחה, כולל אזור מיוחד לקטנטנים. מצויין עבור בילוי של יום שלם, במיוחד בימים חמים.',
          link: {
            url: bangkokGetYourGuideAttractions['siam-amazing-park'],
            text: 'לחצו כאן ובדקו את פארק סיאם בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Safari World',
          text: 'פארק ספארי המשלב ספארי ברכב (בדומה לאפריקה) ופארק ימי עם מופעים של דולפינים, אריות ים וציפורים. חווייה נהדרת לילדים - אך יש לקחת בחשבון את המרחק מהעיר (כ-45 דקות נסיעה).',
          link: {
            url: bangkokKlookAttractions['safari-world'],
            text: 'לחצו כאן ובדקו את Safari World בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'SEA LIFE - Bangkok Ocean World',
          text: 'אקווריום תת-קרקעי עצום ואחד הגדולים באסיה, ממוקם בקומה התחתונה של קניון Siam Paragon. כולל מנהרות שקופות, כרישים, פינגווינים, מדוזות צבעוניות ועוד - חוויה מרתקת גם לילדים וגם למבוגרים, בלב העיר הסואנת.',
          link: {
            url: bangkokKlookAttractions['sea-life'],
            text: 'לחצו כאן ובדקו את SEA LIFE בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Madame Tussauds Bangkok',
          text: 'מוזיאון השעווה המפורסם, חוויה מהנה למשפחות בלב בנגקוק, בקניון Siam Discovery. כאן תמצאו דמויות של כוכבי קולנוע, מנהיגים היסטוריים, מוזיקאים ואייקונים בינלאומיים - חוויה אינטראקטיבית נהדרת למשפחות ולחובבי סלפי.',
          link: {
            url: bangkokGetYourGuideAttractions['sea-life-and-madame-tussauds'],
            text: 'לחצו כאן ובדקו את הכרטיס המשולב של SEA LIFE ו-Madame Tussauds בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
      tourIds: '616103,517600,528510',
    },
    {
      title: 'מוזיאונים בבנגקוק - תרבות, אומנות והיסטוריה מרתקת',
      description:
        'בנגקוק מציע מגוון מוזיאונים המספקים הצצה להיסטוריה, לאמנות ולתרבות התאילנדית.',
      type: 'sub-headers',
      content: [
        {
          subtitle: "מוזיאון ג'ים תומפסון",
          text: "אחד המוזיאונים הייחודיים בעיר הממוקם בבית תאילנדי מקומי מוקף גן ירוק בלב העיר. המוזיאון היה ביתו של ג'ים תומפסון - אמריקאי שפעל להחייאת תעשיית המשי התאילנדית ונעלם באופן מסתורי בשנת 1967. במתחם תמצאו פריטי אמנות אסייתית עתיקה, ריהוט בסיסי וארכיטקטורה תאילנדית קלאסית.<br/> שווה לעצור גם בבית הקפה שבגן - פינה שקטה ונעימה בלב העיר, מושלמת למנוחה קלה אחרי הסיור. בנוסף, סמוך למתחם נמצאת חנות משי איכותית עם פריטים בעבודת יד, למי שמעוניין במזכרת מיוחדת ומקומית באמת.",
          link: {
            url: bangkokGetYourGuideAttractions['jim-thompson-house'],
            text: "לחצו כאן ובדקו את מוזיאון ג'ים תומפסון בעצמכם",
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'מוזיאון Space & Time Cube',
          text: 'חוויה אינטראקטיבית ומלאת דמיון בלב בנגקוק ואשר במסגרתה האמנות פוגשת את הטכנולוגיה ומייצרת מיצגים ייחודיים ומדהימים. המוזיאון מציע חדרים מעוצבים בתאורה מתחלפת, מראות אינסופיות ואשליות אופטיות הגורמות לכל צילום להפוך לאמנות בפני עצמה. אתר פופולרי במיוחד בקרב צעירים וחובבי צילום, המבטיח חוויה מהנה וויזואלית יוצאת דופן.',
          link: {
            url: bangkokGetYourGuideAttractions['space-time-cube-museum'],
            text: 'לחצו כאן ובדקו את מוזיאון Space & Time Cube בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'מוזיאון בנגקוק לאמנות עכשווית (MOCA)',
          text: 'מוזיאון מרהיב המציג יצירות מודרניות ועכשוויות של אמנים תאילנדים בולטים. הבניין מרשים מבחוץ לא פחות מהתערוכות שבתוכו ומהווה מקום מושלם לאוהבי אמנות ולמעוניינים לטעום מהתרבות התאילנדית העכשווית.',
        },
        {
          subtitle: 'מוזיאון ארמון סואן פאקרד (Suan Pakkad Palace)',
          text: 'מתחם שקט ופסטורלי הכולל מספר מבנים בסגנון תאילנדי מסורתי, ששימשו בעבר את משפחת המלוכה. המוזיאון מציג אוספים של אמנות, עתיקות, כלי נגינה מסורתיים ועוד - חוויה מיוחדת בלב העיר הסואנת.',
        },
        {
          subtitle: 'Museum of Siam',
          text: 'מוזיאון חווייתי, מודרני ואינטראקטיבי המיועד לכל המשפחה, הסוקר את התרבות, ההיסטוריה והזהות התאית. מתאים במיוחד למעוניינים להעמיק ולהבין את השאלה "מה זה בעצם להיות תאי?" - בדרך מקורית ומהנה.',
        },
      ],
    },
    {
      title: 'שווקים וקניונים בבנגקוק',
      description: ``,
      type: 'sub-headers',
      content: [
        {
          subtitle: 'שווקים מרכזיים',
          text: `בבנגקוק קיים מגוון רחב של שווקים, שווקי יום, שווקי לילה, שווקי סופ"ש, שווקים באירועים שונים ועוד. אל תפספסו את שוק סוף השבוע צ'אטוצ'אק Chatuchak Weekend Market  - השוק הגדול באסיה ומהווה חוויה אותנטית לאוהבים שופינג ותרבות מקומית גם יחד.`,
          link: {
            url: '/international/thailand/article/bangkok-markets',
            text: 'למדריך המלא על השווקים המרכזיים בבנגקוק',
          },
        },
        {
          subtitle: 'קניונים מרכזיים',
          text: 'בבנגקוק גם מגוון ענק של קניונים, החל מ - Central World / Siam Paragon / IconSiam - קניונים מהגדולים והמפוארים שבעיר, כפרט ובתאילנד כולה ככלל, עם חנויות ממותגות, מתחמי אוכל עשירים, ואטרקציות למשפחות וילדים.',
          link: {
            url: '/international/thailand/article/bangkok-malls',
            text: 'למדריך המלא על הקניונים המרכזיים בבנגקוק',
          },
        },
        {
          subtitle: 'טיפ לקניות ביום אחד',
          text: 'יש לכם יום אחד בלבד לקניות? המלצתנו הינה להתמקד ב"משולש" הכולל את Central World, Platinum Mall ו-Big C Supercenter, השילוה המנצח עבור יום אחד!',
        },
      ],
    },
    {
      title: 'קניון Central World',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok-malls/bangkok-malls-article-2.jpeg',
    },
    {
      title: 'טיולי יום מבנגקוק',
      type: 'sub-headers',
      description:
        'טיולי יום מבנגקוק יכולים להיות מגוונים ומרתקים. ניתן לבקר באתרי מורשת היסטוריים, לחוות שווקים מיוחדים, לטייל בטבע ואפילו לשלב פעילויות כמו שנורקלינג, ביקור בחוות פילים, גני חיות, פארקי מים ושעשועים ועוד.',
      content: [
        {
          subtitle: 'איוטאיה (Ayutthaya)',
          text: 'איוטאיה, בירתה ההיסטורית של תאילנד, ידועה במקדשים העתיקים והמרשימים שלה. המקדשים, שרבים מהם ניזוקו במהלך המלחמה עם מיאנמר, שוחזרו ושומרים על יופיים המקורי. בין המקדשים הבולטים באיוטאיה ניתן למצוא את Wat Yai Chaimongkhon, Wat Mahatat, Wat Si Sanphet ו - Wat Lokayasutharam.',
          link: {
            url: bangkokGetYourGuideAttractions['ayutthaya-temples'],
            text: 'לחצו כאן ובדקו את הטיול לאיוטאיה בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'השוק הצף ושוק הרכבת',
          text: 'השוק הצף Damnoen Saduak Floating Market ושוק הרכבת Talat Rom Hub - Mae klong Railway Market הינם מהמפורסמים והאייקוניים שבשווקי תאילנד. השוק הצף הינו שוק התעלות הצבעוני, בו הסוחרים מוכרים תוצרת טרייה, אוכל ומזכרות מסירותיהם ומדוכנים המצויים על גדות התעלות. שוק הרכבת, מציע חוויה מרתקת כאשר הרכבת עוברת דרך דוכני השוק ובצמוד לדוכנים ולעוברים והשבים במקום ואלו נאלצים לפנות את מרכולתם הצידה כדי לפנות לה מקום.',
          link: {
            url: bangkokGetYourGuideAttractions['train-market-floating-market'],
            text: 'לחצו כאן ובדקו את הטיול לשוק הצף ושוק הרכבת בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'השוק הצף אמפאווה (Amphawa Floating Market)',
          text: 'שוק צף נוסף, אותנטי ומקסים, הפעיל בסופי שבוע (שישי עד ראשון) בלבד. השוק ידוע באווירה הנינוחה שלו, במחירים הזולים ובמגוון המאכלים והמזכרות המוצעים בו. בניגוד לשווקים צפים אחרים, שוק אמפאווה שומר על אופיו המקומי והאותנטי ומציע חוויה תרבותית ייחודית. תמצאו בו מגוון רחב של מאכלים תאילנדיים טעימים וזולים וכן מזכרות, בגדים, תיקים ופריטים נוספים.',
          link: {
            url: bangkokGetYourGuideAttractions[
              'maeklong-railway-amphawa-floating-market'
            ],
            text: 'לחצו כאן ובדקו את הטיול לשוק הצף אמפאווה בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'חוויות קולינריות בבנגקוק - חגיגה של טעמים',
      description:
        "בנגקוק הינה גן עדן לחובבי אוכל - משווקי רחוב שוקקי חיים ועד למסעדות יוקרה עטורות כוכבי מישלן. העיר מציעה מגוון עצום של טעמים - מתבשילים תאיים חריפים, דרך מנות אסייתיות מרחבי היבשת ועד מנת פיוז'ן מודרנית. בין המנות הפופולריות שתמצאו כמעט בכל פינה: פאד תאי, מרק טום יאם, קאו סוי (מרק קארי מהצפון), וסום טאם - סלט פפאיה ירוקה חריף ומרענן.",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'שווקי אוכל מומלצים',
          text: "שווקי הרחוב של בנגקוק הינם מקום מצוין להתחיל בו את ההרפתקה הקולינרית - בדגש על שוק רחוב Yaowarat בצ'יינה טאון (בלילה), שוק Ratchada Night Market, ושוק או טור קור הסמוך לשוק Chatuchak. כל אלו מציעים חוויית טעמים אותנטית במחירים נוחים.",
        },
        {
          subtitle: 'סדנאות בישול בבנגקוק',
          text: 'כיאה ל"גן העדן למטבח התאילנדי", מציעה בנגקוק מגוון רחב של סדנאות בישול תאילנדיות, המתאימות לכל הרמות, החל ממתחילים ועד לטבחים מנוסים. ניתן למצוא סדנאות המשלבות ביקור בשוק מקומי, לימוד של מנות מסורתיות, וגם סדנאות המתמקדות במטבח טבעוני או צמחוני.',
        },
        {
          subtitle: 'סדנאות מומלצות',
          text: 'סדנאות בישול תאילנדיות מובילות בבנגקוק:',
          bulletList: [
            {
              title: 'Tingly Thai Cooking School',
              description:
                'סדנה המתמקדת מעבר למנות עצמן, אף בטכניקות בישול מסורתיות, תובנות מהשוק המקומי וטיפים לבחירת ואחסון מרכיבים טריים. סדנת הבוקר כוללת אף ביקור חווייתי בשוק המקומי.',
              link: {
                url: bangkokGetYourGuideAttractions[
                  'tingly-thai-cooking-school'
                ],
                text: 'לחצו כאן ובדקו את Tingly Thai Cooking School בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: 'Mango Cooking School',
              description:
                'סדנה המתמקדת מטבח תאילנדי, עם דגש על טעמים ומתכונים אותנטיים וכוללת סיורים חווייתיים בשוק המקומי, בסדנאות הבוקר ואחה"צ.',
              link: {
                url: bangkokGetYourGuideAttractions['mango-cooking-school'],
                text: 'לחצו כאן ובדקו את Mango Cooking School בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: 'Maliwan Thai Cooking Class',
              description:
                "סדנה הממוקמת בשכונת באנגלמפו בסמוך לרח' הקוואסאן ומתמקדת במרכיבי המטבח התאילנדי, טכניקות בישול וגם איך להתאים את המנות לטעמכם האישי. הסדנה כוללת סיור חווייתי בשוק המקומי באמצעות טוק טוקים.",
              link: {
                url: bangkokGetYourGuideAttractions[
                  'maliwan-thai-cooking-class'
                ],
                text: 'לחצו כאן ובדקו את Maliwan Thai Cooking Class בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
          ],
        },
      ],
    },
    {
      title: 'חיי לילה בבנגקוק - עיר שלא הולכת לישון',
      description:
        'כשהשמש שוקעת, משנה בנגקוק את פניה - ממטרופולין שוקק למוקד בילויים תוסס. חיי הלילה בעיר מגוונים ומפתיעים: החל מברים על גג (Rooftop Bars) עם נופים עוצרי נשימה של קו הרקיע של העיר, דרך פאבים ומועדונים בקאו סאן רואד וסוקומוויט ועד מסיבות אלקטרוניות עד אור הבוקר.',
      type: 'text',
      content: '',
    },
    {
      title: 'ברים על גג מומלצים',
      type: 'bullet-list',
      description:
        'הברים הגבוהים והמרשימים ביותר בבנגקוק עם נופים עוצרי נשימה:',
      content: [
        {
          title: 'Sky Bar at Lebua',
          description: `אחד מהברים הגבוהים והמרשימים ביותר בעיר. ראו פירוט בפרק "נקודות תצפית" על העיר.`,
        },
        {
          title: 'Mojjo Rooftop Lounge & Bar',
          description:
            'בר תוסס על הגג, ב-Sukhumvit 24 בסמוך לתחנת הרכבת העילית Phrom Phong עם דגש על מוזיקה לטינית, מנות מיוחדות ונוף עוצר נשימה של קו הרקיע של בנגקוק.',
          link: {
            url: bangkokGetYourGuideAttractions['mojjo-rooftop-lounge'],
            text: 'לחצו כאן ובדקו את Mojjo Rooftop בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          title: 'Tichuca Rooftop Bar',
          description:
            'אווירה צעירה ואופנתית, עיצוב טרופי, משקאות מיוחדים ונופים מהממים של העיר. ממוקם ב-Sukhumvit 40 בסמוך לתחנת הרכבת העילית Thong Lor.',
        },
      ],
    },
    {
      title: 'טיולים קולינריים וברים בבנגקוק',
      type: 'sub-headers',
      description: 'טיולים קולינריים מודרכים - לטעום את בנגקוק כמו מקומי',
      content: [
        {
          subtitle: 'חוויות קולינריות מודרכות',
          text: 'אחת הדרכים הטובות ביותר להכיר את בנגקוק, הינה להצטרף לטיול קולינרי מודרך. בטיולים, תכירו את מאחורי הקלעים של סצנת האוכל המקומית - דוכנים סמויים, מתכונים אלוהיים וטעמים שלא תמצאו במדריך הרגיל.',
        },
        {
          subtitle: 'מומלצים במיוחד',
          text: 'חוויות קולינריות יוקרתיות וייחודיות בבנגקוק:',
          bulletList: [
            {
              title: "שייט לילי עם ארוחת ערב בנהר צ'או פראיה בבנגקוק",
              description:
                'זוהי אטרקציה תיירותית, פופולרית אך יוקרתית, המציעה חוויה רומנטית נעימה וייחודית. במסגרת השייט הכולל בדרך כלל ארוחת ערב עשירה בסגנון בופה עם מנות תאילנדיות ובינלאומיות, תהנו ממופעי מוזיקה חיה ולעתים גם מופעי ריקוד תאילנדי מסורתי או קברט ובעיקר מאווירה לילית מיוחדת עם נופים מרהיבים של העיר בנגקוק המוארת בלילה, כולל מקדשים, ארמונות וגשרים.',
              link: {
                url: bangkokGetYourGuideAttractions[
                  'white-orchid-chao-phraya-dinner-cruise-free-beer'
                ],
                text: "לחצו כאן ובדקו את השייט הלילי בנהר צ'או פראיה בעצמכם",
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: 'Bangkok Bustaurant',
              description:
                "מסעדת יוקרה על גלגלים, דרכה תחוו את יופיה הפנורמי של בנגקוק תוך כדי התפנקות עם אוכל משובח באוטובוס דו - קומתי המפואר. במהלך הנסיעה תעברו בין ציוני הדרך האייקוניים ביותר של העיר והמונומנטים ההיסטוריים - המקדשים המוארים, הארמון המלכותי, נהר הצ'או פראייה ועוד וכל זה, בשעה שאתם מתענגים על אוכל משובח ברמה הגבוהה ביותר. אז דמיינו את עצמכם נוסעים ברחובות בנגקוק המוארת, יושבים באוטובוס דו קומתי מהודר שהוסב למסעדה אלגנטית ונהנים מארוחת גורמה יוקרתית תוך כדי סיור באתרים המפורסמים של העיר. המנות מוגשות בסגנון עילי (Fine Dining), עם שירות מוקפד, יינות איכותיים ואווירה בלתי נשכחת.",
              note: 'זו לא עוד ארוחה - זו חוויה קולינרית ותיירותית ייחודית שאין כמוה בבנגקוק!',
              link: {
                url: bangkokKlookAttractions['bustaurant'],
                text: 'לחצו כאן ובדקו את Bustaurant בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
          ],
        },
        {
          subtitle: 'סיורי אוכל מומלצים',
          text: "בנגקוק מציעה מגוון רחב של סיורי אוכל רגליים בשווקים המקומיים, המאפשרים למבקרים לחוות את הסצנה הקולינרית המגוונת של העיר. אפשרויות סיור פופולריות כוללות סיורי טוק - טוק ערביים המתמקדים באוכל רחוב, סיורים ספציפיים לצ'יינה טאון וסיורים ארוכים יותר ברחובות הצדדיים של העיר סיורים אלה כוללים לעתים קרובות מספר עצירות לטעימות אוכל, לעיתים במקומות המופיעים ברשימת דירוגי מישלן ומספקים הזדמנות לטעום מנות פופולריות כמו פאד תאי, סום טאם ומנגו סטיקי רייס.",
          imageUrl: '/images/thailand/bangkok/bangkok-article-4.jpeg',
          imageDescription: "צ'יינה טאון",
          bulletList: [
            {
              title: "סיור אוכל לילי באמצעות טוק טוק בצ'יינה טאון",
              description:
                "סיור זה, מתמקד במיוחד בצ'יינה טאון ומציע צלילה מעמיקה אל סצנת אוכל הרחוב המפורסמת של האזור.",
              link: {
                url: bangkokGetYourGuideAttractions[
                  'michelin-guide-street-food'
                ],
                text: 'לחצו כאן ובדקו את סיור אוכל הרחוב במדריך מישלן על ידי טוק טוק בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: "סיור אוכל לילי, בהליכה רגלית חווייתית, בצ'יינה טאון",
              description:
                "סיור המתמקד אף הוא בצ'יינה טאון אך בהליכה רגלית המאפשרת את ההתחככות באנשים ובטעמים, חווייה מיוחדת!",
              link: {
                url: bangkokGetYourGuideAttractions[
                  'authentic-10-tasting-food-tour'
                ],
                text: 'לחצו כאן ובדקו את סיור האוכל הלילי בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: 'סיור אוכל בחצות בבנגקוק',
              description:
                'סיור פופולרי שייקח אתכם ברחובות העיר בטוק - טוק ובו תטעמו ממגוון מאכלי רחוב בלילה.',
              link: {
                url: bangkokGetYourGuideAttractions['midnight-food-tour'],
                text: 'לחצו כאן ובדקו את סיור האוכל בחצות בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: "A Chef's Tour",
              description:
                'סיור אוכל רגלי, אינטימי ומורחב ברחובות האחוריים והמיוחדים של בנגקוק, מומלץ!',
              link: {
                url: bangkokGetYourGuideAttractions['chef-designed-food-tour'],
                text: "לחצו כאן ובדקו את A Chef's Tour בעצמכם",
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
            {
              title: 'חווייה קולינרית באמצעות אופניים',
              description:
                'סיור אוכל באמצעות אופניים ברחובות האחוריים שהטוק טוק אינו מגיע אליהם. גם להכיר את העיר, גם לפגוש אנשים וגם להכיר ולטעום מהקולינריה המקומית.',
              link: {
                url: bangkokGetYourGuideAttractions[
                  'hidden-bike-food-experience'
                ],
                text: 'לחצו כאן ובדקו את סיור האוכל באמצעות אופניים בעצמכם',
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
          ],
        },
        {
          subtitle: 'ברים מומלצים בבנגקוק',
          text: 'ברים מומלצים לחוויית לילה איכותית בבנגקוק:',
          bulletList: [
            {
              title: 'Vesper',
              description:
                'בר קוקטיילים יוקרתי עם מגע אירופאי, דורג ברשימת 50 הברים הטובים באסיה.',
            },
            {
              title: 'Teens of Thailand',
              description: "בר קטן עם התמחות בג'ין, הממוקם בלב ציינה טאון.",
            },
            {
              title: 'Smalls Bar & Live Music',
              description:
                'בר בוהמייני עם מוזיקה חיה, קומה עליונה פתוחה ונוף יפהפה.',
            },
            {
              title: 'Tropic City',
              description:
                'קוקטיילים טרופיים וצבעוניים באווירה חמה ומוזיקת ​​דיסקו עדינה.',
            },
          ],
        },
      ],
    },
    {
      title: 'טיפים חשובים למטיילים בבנגקוק',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'עונות וזמני ביקור',
          text: 'נובמבר - מרץ הינה התקופה הנוחה ביותר אך בבנגקוק כמו ביתר האזורים בתאילנד, ניתן לטייל בכל זמן!',
        },
        {
          subtitle: 'התארגנות והזמנות',
          text: 'הזמינו לינה מראש (עם אופציית ביטול), דגש על עונות השיא (נובמבר-מרץ).',
        },
        {
          subtitle: 'המלצות כספיות',
          text: 'הביאו דולרים או אירו (שטרות חדשים) - שערי החליפין לעיתים טובים יותר מאשר משיכת כסף בכספומט.',
        },
        {
          subtitle: 'מזג האוויר והתמודדות עמו',
          text: 'בנגקוק חמה ולחה - הקפידו על שתייה והפסקות במקומות ממוזגים.',
        },
        {
          subtitle: 'בטיחות בדרכים',
          text: 'שימו לב לרמזורים ולכלי רכב - אין זכות קדימה להולכי רגל.',
        },
        {
          subtitle: 'ביטחון אישי',
          text: 'שמרו על חפצים אישיים בשווקים צפופים.',
        },
        {
          subtitle: 'לבוש במקדשים',
          text: 'הקפידו על לבוש צנוע - כתפיים וברכיים מכוסות.',
        },
        {
          subtitle: 'המלצות תחבורה',
          text: 'השתמשו באפליקציות Bolt ו-Grab לנסיעות בטוחות ונוחות - הן גם חוסכות התמקחויות מיותרות עם נהגי מוניות וטוקטוקים.',
        },
        {
          subtitle: 'תקשורת אינטרנט',
          text: 'מומלץ לרכוש סים מקומי עם חבילת גלישה בשדה התעופה - מאוד זול ונוח.',
        },
        {
          subtitle: 'טיפים לביקור במוזיאונים',
          text: '✓ <strong>MOCA</strong> - מומלץ בבוקר כשפחות עמוס, אידיאלי ליום גשום.<br />✓ <strong>Suan Pakkad Palace</strong> - חוויה של תרבות והיסטוריה בלב העיר.<br />✓ <strong>Museum of Siam</strong> - מתאים במיוחד למשפחות, סמוך למקדשים כך שניתן לשלב ביקור.<br />✓ <strong>Jim Thompson House</strong> - הצטרפו לסיור המודרך כדי ליהנות מהסיפור ההיסטורי של תעשיית המשי התאילנדי ומהאווירה המיוחדת בבית המסורתי והגן המטופח.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        'בנגקוק הינה עיר של ניגודים - ישן מול חדש, שקט מול רעש, מסורת מול מודרניות - וכל זה במקום אחד תוסס ומלא חיים. העיר מציעה לכל מבקר חוויה חד פעמית ומסע בין תרבות, היסטוריה, קדמה וחדשנות. כל פינה בעיר מספרת סיפור אחר, והקסם שבה טמון דווקא בשילוב הייחודי של כל הניגודים הללו לכדי עיר אחת בלתי נשכחת.',
    },
  ],
};
